<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="dialogBtn" rounded dark class="mb-2 red--text text--accent-4" v-bind="attrs" v-on="on">Add New</v-btn>
    </template>
    <v-card>

      <v-toolbar color="secondary" class="mb-5">
        <v-toolbar-title>Add New Condition</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-autocomplete
            ref="conditions"
            :items="conditions"
            label="Conditions"
            item-text="condition"
            item-value="id"
            :rules="[rules.required]"
            v-model="condition.condition_id"
            prepend-icon="mdi-head-snowflake-outline"
            outlined
            rounded
            dense
          ></v-autocomplete>

          <v-spacer class="text-h6">Date Diagnosed</v-spacer>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                :items="months"
                label="Month Diagnosed"
                prepend-icon="mdi-calendar"
                v-model="condition.month_diagnosed"
                outlined
                rounded
                dense
              ></v-select>
            </v-col>
            <v-col>
              <v-select
                label="Year Diagnosed"
                name="Year"
                rounded
                dense
                :items="years"
                item-text="theyear"
                :rules="[rules.required]"
                item-value="id"
                prepend-icon="mdi-calendar"
                outlined
                v-model="condition.year_diagnosed"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary darken-1" rounded @click="save">Save</v-btn>
        <v-btn color="secondary darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  created() {
    this.$store.dispatch("conditions/aList");
  },
  data: () => ({
    dialog: false,
    valid: true,
    condition: {
      condition_id: "",
      month_diagnosed: "",
      year_diagnosed: ""
    },
    rules: {
      required: v => !! v || "This field is required"
    }

  }),
  computed: {
    ...mapGetters("conditions", {
      conditions: "gList",
    }),
    ...mapGetters( {
      years: "gYears",
      months: "gMonths"
    })
  },
  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    clearForm() {
      this.condition.condition_id = ""
      this.condition.month_diagnosed = ""
      this.condition.year_diagnosed = ""
    },
    save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("conditions/aAdd", this.condition).then(res => {
          if (res) {
            this.clearForm();
            this.dialog = false;
          }
        });
      }
    }
  }
};
</script>

<style>
</style>